<template>
	<div>
		<div _text="26px border [#3E3E3E]">数据统计</div>
		<div _m="t-24px" _flex="~">
			<div
				_w="119px"
				_h="122px"
				_bg="[#F7F8FA]"
				_border="rounded-12px"
				_m="r-10px"
				_p="l-16px"
				_flex="~ col justify-center items-start"
			>
				<span _text="16px [#959596]" _w="64px" _h="22px">作答次数</span>
				<span _m="t-20px">
					<b _text="32px bold [#000000]">{{ questionState.count || 0 }}</b>
					<b _text="14px bold [#3D3D3D]" _m="l-10px">次</b>
				</span>
			</div>
			<div
				_w="119px"
				_h="122px"
				_bg="[#F7F8FA]"
				_border="rounded-12px"
				_m="r-10px"
				_p="l-16px"
				_flex="~ col justify-center items-start"
        v-if="![4, 5, 7, 9, 18].includes(detailData.type)"
			>
				<span _text="16px [#959596]" _w="64px" _h="22px">正确率</span>
				<span _m="t-20px">
					<b _text="32px bold [#000000]"> {{ Math.round(questionState.correct * 100 * 100) / 100 || 0 }} %</b>
				</span>
			</div>
			<div
				_w="119px"
				_h="122px"
				_bg="[#F7F8FA]"
				_border="rounded-12px"
				_m="r-10px"
				_p="l-16px"
				_flex="~ col justify-center items-start"
				v-if="[4, 5, 7, 9].includes(detailData.type)"
			>
				<span _text="16px [#959596]" _w="64px" _h="22px">平均分</span>
				<span _m="t-20px">
					<b _text="32px bold [#000000]">{{ questionState.score || 0 }}</b>
					<b _text="14px bold [#3D3D3D]" _m="l-10px">分</b>
				</span>
			</div>
			<div
				_w="119px"
				_h="122px"
				_bg="[#F7F8FA]"
				_border="rounded-12px"
				_m="r-10px"
				_p="l-16px"
				_flex="~ col justify-center items-start"
				v-for="item in questionState.options"
				:key="item.answer"
			>
				<span _text="16px [#959596]" _w="64px" _h="22px">{{ `选${numToColNo(item.answer)}的人` }}</span>
				<span _m="t-20px">
					<b _text="32px bold [#000000]">{{ item.count }}</b>
					<b _text="14px bold [#3D3D3D]" _m="l-10px">人</b>
				</span>
			</div>
		</div>
		<div _text="26px border [#3E3E3E]" _m="t-20px">作答</div>
		<div _border="1px solid [#ebeef5]" _m="t-24px">
			<el-table :data="list" style="width: 100%;">
				<el-table-column prop="student" label="学生姓名">
					<template slot-scope="{ row }">{{ row.student?.account?.realname }}</template>
				</el-table-column>
				<el-table-column prop="class_name" label="班级">
					<template slot-scope="{ row }">{{ row.classroom?.class_name }}</template>
				</el-table-column>
				<el-table-column prop="created_at" label="作答时间"></el-table-column>
				<el-table-column prop="answer" label="作答结果">
					<template slot-scope="{ row }">
						<div v-if="detailData.type == 1">{{ numToColNo(row.answer) }}</div>
						<!-- <div v-else-if="detailData.type == 2">{{ numToColNoList(row.answer) }}</div> -->
						<div v-else-if="detailData.type == 3">{{ row.answer.map(item => { return item == null || item == undefined ? '"  "' : item }).join('、') }}</div>
						<div v-else-if="[11, 2].includes(detailData.type) && row.answer != [] && row?.extra?.url">
              <hoverShowButton
                :src="row?.extra?.url"
                :buttonViewEvent="() => { openAnswer(row) }"
                :buttonDownloadEvent="() => { downResource2(row) }"
              />
						</div>
						<div v-else-if="([9, 4, 7, 18, 5, 24].includes(detailData.type)) && row.extra">
              <hoverShowButton :src="require('@/assets/image/audioResource2.png')" :buttonViewEvent="() => { audioResource = row?.extra?.url, audioFlag = true }" :buttonDownloadEvent="() => { downResource(row) }"/>
						</div>
            <!-- 排序 -->
            <div v-else-if="detailData.type == 10" _flex="~">
              <span v-for="item in row.answer" :key="item" _m="r-5px" _w="30px" _h="30px" _bg="[#F5F5F5]" _flex="~ items-center justify-center" _border="rounded-[4px]">{{ item }}</span>
						</div>
            <!-- 配色 -->
            <div v-else-if="detailData.type == 14" _flex="~">
              <span v-for="item in row.answer" :key="item" _m="r-5px" _w="30px" _h="30px" _border="rounded-[4px]" :style="{ background: item }"></span>
						</div>
            <!-- 拼图 -->
            <div v-else-if="detailData.type == 13" _flex="~">
              <hoverShowButton
                :src="detailData.extras.pic"
                :buttonViewEvent="() => { openAnswer(row) }"
                :buttonDownloadEvent="() => { downResource2(row) }"
              />
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="final_score" label="得分" v-if="[9, 7, 5, 4].includes(detailData.type)">
          <template slot-scope="{ row }">{{ row.answer || row.final_score }}</template>
        </el-table-column> -->
        <!-- 不知道什么改的评分，当BUG提了 -->
        <el-table-column prop="final_score" label="评分" v-if="[9, 7, 5, 4, 18, 24].includes(detailData.type)">
          <template slot-scope="{ row }">{{ row.answer.score_level }}</template>
        </el-table-column>
			</el-table>
		</div>
		<div _flex="~ justify-between" _m="t-10px">
			<div>总计：{{ total }}条/{{ last_page }}页</div>
			<el-pagination
				:current-page.sync="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="page_size"
				:total="total"
				background
				layout="prev, pager, next, jumper, sizes, slot"
				@current-change="handleCurrentChange"
				@size-change="handleSizeChange"
			>
			</el-pagination>
		</div>

		<el-dialog :show-close="false" :visible.sync="imgFlag" :append-to-body="true" width="620px">
			<div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					_cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="imgFlag = false"
				></i>
        <div v-if="![13].includes(detailData.type)">
          <img :src="imgResource" style="max-width: 600px; max-height: 900px;" />
          <div _text="20px [#676767]" _p="15px" _bg="[#E8E8E8]" _border="rounded-bl-[10px] rounded-br-[10px]" >
            <div _m="b-10px">学生答案</div>
            <div>
              <span v-for="(em, i) in answer" :key="i" _m="r-15px">{{ i + 1 }}-{{ numToColNo(em) }}</span>
              <span v-if="answer?.length == 0">空</span>
            </div>
          </div>
        </div>
        <div v-else _flex="~ wrap justify-center">
          <div v-for="(item, index) in puzzleBase64Array" :key="index"
          :style="
            {
              flexBasis: puzzleBase64Array.length == 4 ? '50%' : puzzleBase64Array.length == 6 ? '33%' : '6%',
            }"
          >
            <img :src="answer[index] != -1 ? puzzleBase64Array.find(e => e.index == [answer[index]])?.url : require('@/assets/image/1.3.1.png')" _bg="black" style="width: -webkit-fill-available;" _m="r-2px">
          </div>
        </div>
			</div>
		</el-dialog>

		<el-dialog :show-close="false" :visible.sync="audioFlag" :append-to-body="true" :width="'350px'" top="40vh">
			<div style="display: flex; justify-content: center; z-index: 2099; position: relative; margin-bottom: 10px;">
				<i
					class="el-icon-close"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="audioFlag = false"
					_cursor="pointer"
				></i>
				<!-- https://xhmy-test-file.aihuacheng.com/2023/09/21/HG3DUcri7DRoHCNLH3HCkV0EQWgWSjM59NEJ16Hw2PO9Zxtw1a46uko8a3DLeJYL.mp3 -->
				<audio ref="audioRef" @click.stop controls :src="audioResource" controlslist="noplaybackrate nodownload"></audio>
			</div>
		</el-dialog>


    <div ref="canvas" _pos="fixed" _z="-99" style="max-width: 600px;">
      <div v-if="![13].includes(detailData.type)">
        <img :src="imgResource" style="max-width: 600px; max-height: 900px;" />
        <div _text="20px [#676767]" _p="15px" _bg="[#E8E8E8]" _border="rounded-bl-[10px] rounded-br-[10px]" v-if="![13].includes(detailData.type)">
          <div _m="b-10px">学生答案</div>
          <div>
            <span v-for="(em, i) in answer" :key="i" _m="r-15px">{{ i + 1 }}-{{ numToColNo(em) }}</span>
            <span v-if="answer?.length == 0">空</span>
          </div>
        </div>
      </div>
      <div v-else _flex="~ wrap justify-center">
        <div v-for="(item, index) in puzzleBase64Array" :key="index"
        :style="
          {
            flexBasis: puzzleBase64Array.length == 4 ? '50%' : puzzleBase64Array.length == 6 ? '33%' : '6%',
          }"
        >
          <img :src="answer[index] != -1 ? puzzleBase64Array.find(e => e.index == [answer[index]])?.url : require('@/assets/image/1.3.1.png')" _bg="black" style="width: -webkit-fill-available;" _m="r-2px">
        </div>
      </div>
    </div>

	</div>
</template>
<script>
import { musical } from './const.js'
import hoverShowButton from './hoverShowButton.vue'
import axios from 'axios'
import html2canvas from 'html2canvas';
export default {
  components: { hoverShowButton },
	props: {
		detailData: Object,
    puzzleBase64Array: Array
	},
	data() {
		return {
			imgFlag: false,
			imgResource: '',
			audioFlag: false,
			audioResource: '',
			questionState: {},
			musical,
			input: '',
			list: [],
			selectId: '',
			checkMusical: [],
			total: 0,
			last_page: 0,
			page: 1,
			page_size: 10,
      answer: '',
      scoreScopes: [
        { level: 'A', str: '优秀', condition: (num) => 80 <= num && num <= 100},
        { level: 'B', str: '良好', condition: (num) => 60 <= num && num < 80},
        { level: 'C', str: '一般', condition: (num) => 40 <= num && num < 60},
        { level: 'D', str: '一般', condition: (num) => 0 <= num && num < 40},
      ]
		}
	},
	watch: {
		detailData: {
			handler(item) {
				if (item?.id) {
					// 获取数据
					this.getQuestionState()
					this.getQuestionStateList()
				}
			},
			deep: true,
			immediate: true
		},
    puzzleBase64Array: {
      handler(item) {
        console.log(item, '=1=1=1=')
      },
			deep: true,
			immediate: true
    },
		audioFlag: {
      handler(vla) {
        if (!vla) {
          this.$refs?.audioRef?.pause()
        }
      }
    },
	},
	methods: {
    questionScoreConvert(score) {
      const data = { level: '', str: '' }
      const scoreNum = Number(score)
      if (!isNaN(scoreNum)) {
        const scoreVal = this.scoreScopes.find(v => v.condition(scoreNum))
        if (scoreVal) {
          data.level = scoreVal.level
          data.str = scoreVal.str
        }
      }
      else {
        const scoreVal = this.scoreScopes.find(v => v.level == score)
        if (scoreVal) {
          data.level = scoreVal.level
          data.str = scoreVal.str || '加油'
        }
      }
      return data
    },
    openAnswer(row){
      this.imgResource = row?.extra?.url
      this.answer = row.answer
      this.imgFlag = true
    },
    async downResource2(row) {
      const loading = this.$loading({
				lock: true,
				text: '正在导出中',
				spinner: 'el-icon-loading'
			})
      const { extra, student, answer } = row
      this.imgResource = extra?.url
      this.answer = answer
      await new Promise(resolve => setTimeout(() => { resolve() }, 100))
      html2canvas(this.$refs.canvas, { useCORS: true }).then(canvas => {
        const image = canvas.toDataURL('image/png');
        const downloadLink = document.createElement('a');
        downloadLink.href = image;
        downloadLink.download = student.account.realname + '的作答结果';
        downloadLink.click();
        loading.close()
      });
    },
		downResource(row) {
			const { extra, student } = row
			axios.get(extra.url, { responseType: 'blob' }).then(res => {
				const url = window.URL.createObjectURL(new Blob([res.data]))
				let a = document.createElement('a')
				a.href = url
				a.download = student.account.realname + '的作答结果.' + res.data.type.split('/')[1]
				a.click()
				window.URL.revokeObjectURL(url)
			})
		},
		// 数字转换字母
		numToColNo(num) {
			if (num < 0 || num > 26) {
				return ''
			}
			const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
			return letters.charAt(num)
		},
		numToColNoList(e) {
			let answer = []
			e?.forEach(item => {
				answer.push(`${this.numToColNo(item)}`)
			})
			return answer.join('、')
		},
		async getQuestionState() {
			// const data = await this.$api.question_set.getQuestionState(110)
			const data = await this.$api.question_set.getQuestionState(this.detailData.id)
			this.questionState = data
		},
		// 更改条数
		handleSizeChange(val) {
			this.page = 1
			this.page_size = val
			this.getQuestionStateList()
		},
		// 更改页码
		handleCurrentChange(val) {
			this.page = val
			this.getQuestionStateList()
		},
		async getQuestionStateList() {
			const { data, meta } = await this.$api.question_set.getQuestionStateList({
				page: this.page,
				page_size: this.page_size,
				question_id: this.detailData.id
				// question_id: 110
			})
			this.list = data
			this.total = meta.total
			this.last_page = meta.last_page
		}
	},
	async mounted() {
  }
}
</script>
<style lang="scss" scoped>
.genealogy {
	/deep/ .el-dialog__header {
		padding-bottom: 0px !important;
	}
}
</style>
